function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import './header.scss';
export default /*#__PURE__*/_asyncToGenerator(function* () {
  $('.js-mobile-toggle').click(function (e) {
    e.preventDefault();
    $('html').toggleClass('is-open-menu');
  });
  $(window).scroll(function () {
    if ($(window).scrollTop() >= 1) {
      $('.header__navigation').addClass('header__navigation--sticky');
    } else {
      $('.header__navigation').removeClass('header__navigation--sticky');
    }
  });
});